<template>
  <div class="delete-link">
    <div class="link" @click="deleteCommunity()">
      <span>{{ $t('administrator.deleteCommunity.delete') }}</span>
    </div>
    <modal-confirm
      class="confirm-unreport"
      @click.stop
      @confirm="confirmDelete()"
      @close="closeModal()"
      :cancel="$t('administrator.deleteCommunity.no')"
      :confirm="$t('administrator.deleteCommunity.yes')"
      :title="$t('administrator.deleteCommunity.deleteCommunity')"
      :message="$t('administrator.deleteCommunity.deleteConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'DeleteCommunity',
  components: { ModalConfirm },
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    deleteCommunity () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async confirmDelete () {
      this.closeModal()
      let message = this.$t('administrator.deleteCommunity.communityDeleted')
      let success = await this.$store.dispatch('deleteCommunity', this.communityId)
      if (success) {
        this.$toasted.global.success(message)
      }
    }
  }
}

</script>

<style scoped lang="scss">
  .delete-link {
    width: 100%;
    .link {
        color: $primary-color;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -ms-flex-pack: start;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 14px;

        &:hover  {
          cursor: pointer;
          background-color: $primary-color;
          color: white;
        }
      }
  }
</style>
